import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import React, { FC, useMemo, useRef } from 'react';
import styles from './index.module.scss';
import { V2ProductionCostGetProductionCostPostResponse } from '@maxtropy/device-customer-apis-v2';
import { DateType, getTimeAxis } from '@/pages/GlicoUnitComsumption/utils';
import { getChartOption } from './charts';
import { EchartsWithThemeRef } from '@maxtropy/components/es/components/EchartsWithTheme';
import { isNil } from 'lodash-es';

export interface IChart {
  data?: V2ProductionCostGetProductionCostPostResponse;
  loading?: boolean;
  timeResolution?: DateType;
}

const Chart: FC<IChart> = props => {
  const { data, loading, timeResolution } = props;
  const theme = useTheme();
  const chartRef = useRef<EchartsWithThemeRef>();

  // 图表
  const chartOption = useMemo(() => getChartOption(timeResolution, data), [data, timeResolution]);

  return (
    <EchartsWithTheme
      theme={theme}
      loading={loading}
      empty={{
        isShowEmpty: data?.costDetailChartList?.length === 0,
        emptyNode: <Empty className={styles.empty_box} />,
      }}
      ref={d => {
        if (d) {
          chartRef.current = d;
        }
      }}
      onEvents={{
        brushSelected: (params: any) => {
          var brushed: any[] = [];
          let startTime;
          let endTime;
          var brushComponent = params.batch[0];
          const chartObject = chartRef.current?.getInstance();
          const series = chartObject?.getOption()?.series as any[];
          brushComponent.selected.forEach((item: any) => {
            const findSeries = series?.find(i => i.name === item.seriesName);
            if (findSeries && findSeries.type === 'bar') {
              let arr: any[] = [];
              item.dataIndex.forEach((c: number, index: number) => {
                if (index === 0) {
                  startTime = getTimeAxis(findSeries.timeResolution, findSeries.data[c][0]);
                }
                if (index === item.dataIndex.length - 1) {
                  endTime = getTimeAxis(findSeries.timeResolution, findSeries.data[c][0]);
                }
                arr.push(findSeries.data[c][1]);
              });
              let total = null;
              if (arr.filter(x => !isNil(x)).length > 0) {
                total = arr.filter(x => !isNil(x)).reduce((a, b) => a + b);
              }
              brushed.push(
                item.seriesName + '（累计）：' + (!isNil(total) ? total.toFixed(2) : '--') + findSeries.unit
              );
            }
          });
          if (brushComponent.areas.length > 0) {
            chartObject?.setOption({
              title: {
                show: true,
                padding: 8,
                backgroundColor: 'rgba(0,0,0,0.8)',
                borderColor: 'transparent',
                borderRadius: 2,
                textStyle: {
                  color: 'rgba(255,255,255,0.85)',
                  fontSize: 12,
                  fontWeight: 500,
                },
                text: startTime + ' ~ ' + endTime + '\n\n' + brushed.join('\n\n'),
                top: 100,
                // top: 0,
                // right: 260,
                left: brushComponent.areas[0].range[1] - 240,
                zlevel: 99999,
              },
            });
          } else {
            chartObject?.setOption({
              title: {
                show: false,
              },
            });
          }
        },
      }}
      style={{ height: 650, width: '100%' }}
      option={chartOption}
    />
  );
};

export default Chart;
